import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { _ } from 'vue-underscore';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Master Proyek',
    title_department: 'Master Department',
    title_produk: 'Master Produk',
    title_pajak: 'Daftar Pajak',
    title_form_pajak: 'Harta Tetap (Fixed Asset)',
    title_harta_tetap: 'Master Data Harta Tetap',
    title_form_harta_tetap: 'Harta Tetap (Fixed Asset)',
    title_rekening: 'Daftar Akun',
    title_mata_uang: 'Daftar Mata Uang',
    title_proyek: 'Daftar Proyek',
    title_satuan: 'Daftar Satuan Produk',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Proyek',
        href: '/adm/fin/master/proyek',
        active: true,
      },
    ],
    breadcrumb_department: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Proyek',
        href: '/adm/fin/master/proyek',
        active: true,
      },
    ],
    showmodal: false,
    items_rekening: [
      {
        id: 1,
        kode_akun: '1600000010',
        nama_akun: 'Investasi Saham',
        subklasifikasi: 'Investasi Jangka Panjang',
        klasifikasi: 'Harta',
      },
      {
        id: 2,
        kode_akun: '1600000011',
        nama_akun: 'Investasi Saham',
        subklasifikasi: 'Investasi Jangka Panjang',
        klasifikasi: 'Harta',
      },
      {
        id: 3,
        kode_akun: '1600000011',
        nama_akun: 'Investasi Saham',
        subklasifikasi: 'Investasi Jangka Panjang',
        klasifikasi: 'Harta',
      },
    ],
    items_matauang: [
      {
        id: 1,
        kode_matauang: 'USD',
        nama_matauang: 'Dollar',
        tgl_matauang: '09/09/21',
        nilai_tukar: '10000',
      },
    ],
    items_proyek: [],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields_project: [
      {
        key: 'project_no',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'project_name',
        label: 'Nama Proyek',
        sortable: true,
      },
      {
        key: 'manajer',
        label: 'Manajer Proyek',
      },
      {
        key: 'desc_project',
        label: 'Deskripsi',
      },
      {
        key: 'jenis_project',
        label: 'Jenis',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_department: [
      {
        key: 'department_no',
        label: 'Nomor',
        sortable: true,
      },
      {
        key: 'department_name',
        label: 'Nama Department',
        sortable: true,
      },
      {
        key: 'pic',
        label: 'Penanggung Jawab',
      },
      {
        key: 'bidang',
        label: 'Bidang',
      },
      {
        key: 'keterangan',
        label: 'Keterangan',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_rekening: [
      {
        key: 'kode_akun',
        label: 'Kode Akun',
        sortable: true,
      },
      {
        key: 'nama_akun',
        label: 'Nama Akun',
        sortable: true,
      },
      {
        key: 'subklasifikasi',
        label: 'Subklasifikasi',
        sortable: true,
      },
      {
        key: 'klasifikasi',
        label: 'Klasifikasi',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_matauang: [
      {
        key: 'kode_matauang',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'nama_matauang',
        label: 'Nama Mata Uang',
        sortable: true,
      },
      {
        key: 'tgl_matauang',
        label: 'Per Tanggal',
        sortable: true,
      },
      {
        key: 'nilai_tukar',
        label: 'Nilai Tukar',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_proyek: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'proyek',
        label: 'Nama Proyek',
        sortable: true,
      },
      {
        key: 'jenis_proyek',
        label: 'Jenis Proyek',
        sortable: true,
      },
      {
        key: 'manajer_proyek',
        label: 'Manajer Proyek',
        sortable: true,
      },
      {
        key: 'deskripsi',
        label: 'Deskripsi',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_produk: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'proyek',
        label: 'Nama Produk',
        sortable: true,
      },
      {
        key: 'satuan',
        label: 'Satuan',
        sortable: true,
      },
      {
        key: 'stok',
        label: 'Stok',
        sortable: true,
      },
      {
        key: 'merk',
        label: 'Merk',
        sortable: true,
      },
      {
        key: 'part_number',
        label: 'Part Number',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_satuan: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'nama_satuan',
        label: 'Nama Satuan',
        sortable: true,
      },
      {
        key: 'keterangan',
        label: 'Keterangan',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_pajak: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'nama_pajak',
        label: 'Nama Pajak',
        sortable: true,
      },
      {
        key: 'presentase',
        label: 'Presentase',
        sortable: true,
      },
      {
        key: 'akun_beli',
        label: 'Akun Beli',
        sortable: true,
      },
      {
        key: 'akun_jual',
        label: 'Akun Jual',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_hartatetap: [
      {
        key: 'kode',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'nama',
        label: 'Nama',
        sortable: true,
      },
      {
        key: 'kelompok',
        label: 'Kelompok',
        sortable: true,
      },
      {
        key: 'penyusutan',
        label: 'Penyusutan',
        sortable: true,
      },
      {
        key: 'akumulasi',
        label: 'Akumulasi',
        sortable: true,
      },
      {
        key: 'nilai_buku',
        label: 'Nilai Buku',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    tab: [
      {
        name: 'Supplier',
        active: true,
      },
      {
        name: 'Kode Akun dan HPP',
        active: false,
      },
    ],
    detail: false,
    form: {
      principle_code: '',
      principle_name: '',
      code: '',
      company: '',
      company_group: '',
      address: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      email: '',
      phone: '',
      fax: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  activeTab(state) {
    let tabActive = _.findWhere(state.data.tab, {
      active: true,
    });

    return tabActive ? tabActive.name : '';
  },
};

export const mutations = {
  changeMasterFinance(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchCustomer(context, params = null) {
    let result = await ApiGetRequest(`opr/customers`, params);
    return !result.error ? result.data.object : [];
  },

  async getListCustomer({ commit, state }) {
    commit('changeMasterFinance', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      _limit: data.limit,
      _page: data.page,
      _sort: data.sortBy,
      _order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/customers`, params);
    commit('changeMasterFinance', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailCustomer({ commit }, payload = null) {
    commit('changeMasterFinance', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/customers/${payload.id}`);
    commit('changeMasterFinance', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async createCustomer({ commit, state, dispatch }) {
    commit('changeMasterFinance', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/customers`, state.data.form);
    commit('changeMasterFinance', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCustomer({ commit, state, dispatch }, payload = null) {
    commit('changeMasterFinance', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/customers/${payload.id}`,
      state.data.form
    );

    commit('changeMasterFinance', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCustomer({ commit, dispatch }, payload = null) {
    commit('changeMasterFinance', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/customers/${payload.id}`);
    commit('changeMasterFinance', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
